<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">代理商名称</label>
            <span class="weui-form-preview__value">{{item.agentname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">代理商编号</label>
            <span class="weui-form-preview__value">{{item.agentcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本位币</label>
            <span class="weui-form-preview__value">{{item.defaultcurrency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">年份</label>
            <span class="weui-form-preview__value">{{item.y}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">年营业额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.yearamount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">1月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount1}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">2月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount2}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">3月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount3}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">4月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount4}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">5月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount5}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">6月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount6}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">7月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount7}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">8月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount8}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">9月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount9}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">10月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount10}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">11月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount11}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">12月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.'">{{item.amount12}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var item = this.$route.params.item
    return {
      item
    };
  }
}
</script>